import { allSettled } from '@/core/helpers/promise.helpers'
import { apiErrorHandler } from '@/core/helpers/api.helpers'
import { Unauthorized } from '@/app/errors/Entitlement.errors'
import store from '@/store'

/**
 *  Boot app
 *
 * @param dispatch
 * @param rootGetters
 *
 * @returns {Promise<any>}
 */
export const boot = (state, mode) => {
  const appActions = {
    'tasks/boot': { task: 'read' },
    'companies/boot': { company: 'read' },
    'entitlements/boot': { admin: 'read', admin_role: 'read' },
    'assessmentConfigs/boot': { task: 'read' },
    'users/boot': { user_type: 'read' }
  }

  const companyActions = {
    'scores/boot': { score: 'read' }
  }

  const actions = mode !== 'company' ? Object.assign({}, appActions, companyActions) : companyActions

  return load(state, actions)
}

const load = ({ dispatch, rootGetters }, actions) => {
  if (!store.state.auth.authenticated) {
    return
  }

  const boot = rootGetters['auth/entitlements'].getAnyPassed(actions).map(action => dispatch(action, null, { root: true })).map(allSettled)

  return Promise.all(boot)
    .then(boots => {
      const responses = boots.reduce((responses, boot) => {
        responses.push(...(boot.response || boot.error || []))
        return responses
      }, [])

      const rejections = responses.filter(response => response.status === 'rejected' && !(response.error instanceof Unauthorized))

      if (rejections.length > 0) {
        const message = rejections.map(rejection => apiErrorHandler(rejection.error))
        throw message
      }

      return responses
    })
}

export default {
  boot
}
